import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { ProductProposal } from '../model/product-proposal';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProductHttpService {
  private readonly productBaseUrl: string = `${environment.baseUrl}/productProposals`;
  private productList: BehaviorSubject<ProductProposal[]> = new BehaviorSubject<
    ProductProposal[]
  >([]);
  private subscription: Subscription | null = null;

  constructor(private httpClient: HttpClient) {
    setInterval(
      () => {
        this.subscription?.unsubscribe();
        this.loadProductList();
      },
      10 * 60 * 1000,
    ); //10 min polling
  }

  getProductProposalList(): Observable<ProductProposal[]> {
    if (this.productList.getValue().length === 0) {
      this.loadProductList();
    }
    return this.productList;
  }

  private loadProductList(): void {
    this.subscription = this.httpClient
      .get<ProductProposal[]>(`${this.productBaseUrl}`)
      .subscribe((productList) => {
        this.productList.next(productList);
      });
  }
}
